import React from "react";
import "../../styles/aboutUs.css"; 
import about from "../../assets/abthero.jpeg"

const AboutUs = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        
        {/* LEFT SIDE: IMAGE */}
        <div className="about-image-side">
          <img 
            src={about} 
            alt="Group Study" 
            className="about-img"
          />
        </div>

        {/* RIGHT SIDE: TEXT */}
        <div className="about-text-side">
          <h2 className="about-title">About the Courses</h2>
          
          <p className="about-description">
            Madhi Academy offers specialized coaching for India's top professional 
            qualifications – Chartered Accountancy (CA), Cost & Management 
            Accountancy (CMA), and Company Secretary (CS).
          </p>
          
          <p className="about-sub-description">
            Our expert faculty ensure that students not only pass exams but excel in 
            their careers with practical skills and industry insights.
          </p>

          {/* FEATURE LIST */}
          <div className="about-features">
            
            <div className="feature-item">
              <div className="icon-circle">
                <i className="bi bi-book"></i> {/* Bootstrap Icon 'book' */}
              </div>
              <span className="feature-text">
                <strong>Recorded + Live Q&A:</strong> Flexible learning for busy students.
              </span>
            </div>

            <div className="feature-item">
              <div className="icon-circle">
                <i className="bi bi-book"></i>
              </div>
              <span className="feature-text">
                <strong>Daily Personal/Small Group Tuition</strong> – Focused doubt-solving.
              </span>
            </div>

            <div className="feature-item">
              <div className="icon-circle">
                <i className="bi bi-book"></i>
              </div>
              <span className="feature-text">
                <strong>Printed & Digital Notes</strong> – For in-depth revision.
              </span>
            </div>

            <div className="feature-item">
              <div className="icon-circle">
                <i className="bi bi-book"></i>
              </div>
              <span className="feature-text">
                <strong>Test Series & Mock Exams</strong> – To ensure exam readiness.
              </span>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutUs;